import { compact } from 'lodash';
import { ImportAnnotationConflict } from '../models/ImportAnnotationsConflicts';

interface IDatasetImportPart {
  DataSets: {
    DataSetName: string;
    Images: {
      ImageName?: string;
      ImageURL?: string;
    }[];
  }[];
}

export class CheckForAnnotationsConflictsRequest {
  dataSets: ImportAnnotationDataSet[];
  projectId: string;

  constructor(fileContent: string, projectId: string) {
    this.projectId = projectId;
    this.dataSets = (JSON.parse(fileContent) as IDatasetImportPart).DataSets.map((ds) => ({
      dataSetName: ds.DataSetName,
      images: compact(
        ds.Images.map((i) => {
          const imageName = i.ImageName ? i.ImageName : i.ImageURL;
          return imageName ? { imageName } : undefined;
        })
      ),
    }));
  }
}

interface ImportAnnotationDataSet {
  dataSetName: string;
  images: ImportAnnotationsImage[];
}

interface ImportAnnotationsImage {
  imageName: string;
}

export class ImportAnnotationsRequest {
  file: File;
  resolvedConflicts: ImportAnnotationConflict[];
  projectId: string;
  constructor(projectId: string, file: File, resolvedConflicts: ImportAnnotationConflict[]) {
    this.file = file;
    this.projectId = projectId;
    this.resolvedConflicts = resolvedConflicts;
  }

  toFormData(): FormData {
    const formData: FormData = new FormData();
    formData.append('file', this.file);
    formData.append('resolvedConflicts', JSON.stringify(this.resolvedConflicts));
    formData.append('projectId', this.projectId);
    return formData;
  }
}
